import React from 'react';
import { getDuplicatedCss, shouldAddLegacyPaddingBottom, designConsts } from '@wix/native-pro-gallery-utils';
import { GALLERY_CONSTS, options, optionsMap } from 'pro-gallery-lib';
import { utils } from '../../common/utils/utils';
import CustomButton from '../buttons/CustomButton.js';
import Title from './Title.js';
import Description from './Description.js';
import lineHeightFixer from './LineHeightFixer.js';
export default class Texts extends React.Component {
  constructor(props) {
    super(props);
    this.debouncedTryFixLineHeight = utils.debounce(this.tryFixLineHeight.bind(this), 500).bind(this);
  }
  getTextsClassNames() {
    const {
      showShare,
      isNarrow
    } = this.props;
    const classNames = ['info-element-text'];
    if (showShare) {
      classNames.push('hidden');
    }
    if (isNarrow) {
      classNames.push('narrow-item');
    }
    return classNames.join(' ');
  }
  getTextsStyles() {
    const {
      options,
      style
    } = this.props;
    let textsStyles = {
      alignItems: options.controllers_layoutParams_info_horizontalAlignment,
      textAlign: options.galleryTextAlign
    };
    if (GALLERY_CONSTS.hasExternalVerticalPlacement(options[optionsMap.layoutParams.info.placement])) {
      textsStyles = {
        ...textsStyles,
        ...getDuplicatedCss(options)
      };
    }
    // Horizontal placement is not yet implemented in wix editor, but the gallery support it (for example in the designed presets)
    if (GALLERY_CONSTS.hasExternalHorizontalPlacement(options[optionsMap.layoutParams.info.placement])) {
      textsStyles = {
        ...textsStyles,
        ...getDuplicatedCss(options),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: options.controllers_layoutParams_info_verticalAlignment
      };
    }
    if (GALLERY_CONSTS.hasHoverPlacement(options[optionsMap.layoutParams.info.placement])) {
      textsStyles = {
        ...textsStyles,
        ...{
          display: 'flex',
          justifyContent: options.controllers_layoutParams_info_verticalAlignment,
          alignContent: options.controllers_layoutParams_info_verticalAlignment
        }
      };
    }
    if (GALLERY_CONSTS.isLayout('SLIDESHOW')(options)) {
      textsStyles = {
        ...textsStyles,
        paddingTop: '0px'
      };
    }
    const isCentered = style.justifyContent === 'center';
    if (shouldAddLegacyPaddingBottom(this.props)) {
      // Set the texts fixed height considering the height of the love and share buttons which is about 100px;
      textsStyles.paddingBottom = 70;
    }
    if (isCentered) {
      textsStyles.marginTop = style.height / 15;
    }
    if (options[optionsMap.behaviourParams.gallery.layoutDirection] === GALLERY_CONSTS[optionsMap.behaviourParams.gallery.layoutDirection].RIGHT_TO_LEFT) {
      textsStyles.direction = 'rtl';
    } else {
      textsStyles.direction = 'ltr';
    }
    return textsStyles;
  }
  getItemTexts() {
    const {
      title,
      description,
      id,
      options,
      style,
      isNarrow,
      shouldShowButton,
      container
    } = this.props;
    const shouldShowTitle = title && options.controllers_layoutParams_info_allowTitle;
    const shouldShowDescription = description && options.controllers_layoutParams_info_allowDescription;
    let titleStyle, descStyle;
    let titleMarginBottom;
    if (shouldShowDescription) {
      titleMarginBottom = options.titleDescriptionSpace;
    } else if (shouldShowButton) {
      titleMarginBottom = designConsts.spaceBetweenElements;
    } else {
      titleMarginBottom = 0;
    }
    titleStyle = {
      overflow: 'visible',
      marginBottom: titleMarginBottom
    };
    if (shouldShowButton) {
      descStyle = {
        marginBottom: designConsts.spaceBetweenElements
      };
    } else {
      descStyle = {
        marginBottom: 0
      };
    }
    if (GALLERY_CONSTS.isLayout('SLIDESHOW')(options) && container && container.galleryWidth && container.galleryWidth < 800) {
      let maxWidth = container.galleryWidth;
      if (options[optionsMap.behaviourParams.gallery.horizontal.slideshowInfo.enableCounter]) {
        maxWidth -= 30;
      }
      if (options[optionsMap.behaviourParams.gallery.horizontal.slideshowInfo.enablePlayButton]) {
        maxWidth -= 30;
      }
      titleStyle.maxWidth = maxWidth;
      descStyle.maxWidth = maxWidth;
    }
    const titleElem = shouldShowTitle && /*#__PURE__*/React.createElement(Title, {
      key: 'item-title-' + id,
      title: title,
      style: titleStyle
    });
    const descriptionElem = shouldShowDescription && /*#__PURE__*/React.createElement(Description, {
      key: 'item-description-' + id,
      description: description,
      style: descStyle
    });
    const buttonElem = shouldShowButton && /*#__PURE__*/React.createElement(CustomButton, {
      type: "button",
      options: options,
      style: style,
      small: isNarrow,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    });
    const shouldHideElement = !titleElem && !descriptionElem && !buttonElem;
    if (shouldHideElement) {
      return null;
    }
    const textsStyles = this.getTextsStyles();
    const textsClassNames = this.getTextsClassNames();
    const allTextsElements = /*#__PURE__*/React.createElement(React.Fragment, null, titleElem, descriptionElem, buttonElem);
    return /*#__PURE__*/React.createElement("div", {
      style: textsStyles,
      ref: x => this.container = x,
      className: textsClassNames,
      dir: "auto"
    }, GALLERY_CONSTS.isLayout('SLIDESHOW')(options) ? allTextsElements : /*#__PURE__*/React.createElement("div", null, allTextsElements) // wrapped with div for flex alignment purposes
    );
  }
  tryFixLineHeight() {
    const isFixed = lineHeightFixer.fix(this.props, this.container);
    if (!isFixed) {
      setTimeout(() => {
        lineHeightFixer.fix(this.props, this.container);
      }, 1000); // waiting for wix inline styles to take affect
    }
  }
  componentDidUpdate(prevProps) {
    if (lineHeightFixer.shouldFix(prevProps, this.props)) {
      this.debouncedTryFixLineHeight();
    }
  }
  componentDidMount() {
    this.tryFixLineHeight();
  }
  render() {
    return this.getItemTexts();
  }
}
//# sourceMappingURL=Texts.js.map